// DEPRECATED: Helper function to format currency values with hardcoded $ symbol

import { dateFormat } from '@/constants/dateFormat'
import { formatters, Timezone } from '@/utils/intl/dateTimeFormatters'
import dayjs from 'dayjs'

// Use useCurrencyFormatters() from dynamicCurrency.ts instead
export function formatCurrency(value: number): string {
  if (value === 0) return '$0.00'
  const sign = value < 0 ? '-' : ''
  return `${sign}$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// Helper function to format volume values
export function formatVolume(value: number): string {
  if (value === 0) return '0'
  const sign = value < 0 ? '-' : ''
  return `${sign}${Math.abs(value).toLocaleString('en-US')}`
}

// DEPRECATED: Helper function to format variance values with hardcoded $ symbol
// Use useCurrencyFormatters() from dynamicCurrency.ts instead
export function formatVariance(value: number, isComparison = false): string {
  if (!isComparison) {
    return formatCurrency(value)
  }

  if (value === 0) return '$0.00'
  const sign = value > 0 ? '+' : '-'
  return `${sign}$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// Helper function to format volume variance
export function formatVolumeVariance(value: number, isComparison = false): string {
  if (!isComparison) {
    return formatVolume(value)
  }

  if (value === 0) return '0'
  const sign = value > 0 ? '+' : '-'
  const formattedValue = Math.abs(value).toLocaleString('en-US')
  return `${sign}${formattedValue}`
}

// DEPRECATED: Helper function to format per unit values with hardcoded $ symbol
// Use useCurrencyFormatters() from dynamicCurrency.ts instead
export function formatPerUnit(value: number | null | undefined, isComparison = false): string {
  // Handle null/undefined values for comparison rows
  if (value === null || value === undefined) {
    return isComparison ? 'N/A' : '$0.0000'
  }

  if (value === 0) return '$0.0000'
  const sign = value < 0 ? '-' : ''
  const formatted = `${sign}$${Math.abs(value).toFixed(4)}`

  if (!isComparison) {
    return formatted
  }

  const comparisonSign = value > 0 ? '+' : ''
  return `${comparisonSign}${formatted}`
}

export function formatInvoiceDate(value: string | null | undefined, tz: Timezone): string {
  if (!value) return 'N/A'
  if (!tz || tz === 'UTC') return dayjs.utc(value).format(dateFormat.DATE_SLASHES)
  return formatters.DATE(value, tz) ?? 'N/A'
}
